// i18n area 'vms' — locale sq-AL (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/vms.sq-AL.meta.json.
import type { enUS } from './vms'

export const sqAL: typeof enUS = {
  vms: {
    spof: {
      title: 'Pavarësia nga nyja',
      single: 'Pikë e vetme dështimi',
      alternativesNow: 'Alternativa tani',
      structural: 'Sipas ndërtimit',
      binding: 'Kufizim përcaktues',
      movableNow: 'Migrimi i mundur tani',
    },
    title: 'Makinat virtuale',
    migratingChip: 'Migrim në proces',
    templateChip: 'Shabllon',
    expendableTooltip: 'Në një klaster të degraduar është ndër të parat që bien dhe mund të mos riniset pas humbjes së një nyje.',
    expendableHaTooltip: 'Gjithmonë e rinisur sa kohë klasteri është i shëndetshëm; në një klaster të degraduar VM-të e mbrojtura vijnë të parat — mund të ndalet ose të mbetet e fikur derisa klasteri të rikthehet i plotë, pastaj riniset vetë.',
    viewDetails: 'Shiko detajet',
    profileLegacy: 'OS tjetër',
    hugePagesNone: 'Asnjë — memorie normale',
    hugePages2M: 'Faqe prej 2 MiB',
    hugePages1G: 'Faqe prej 1 GiB',
    searchPlaceholder: 'Kërko sipas emrit',
    name: 'Emri',

    // Terminologia UNA (#94a): la phase si chiama 'Fase' ovunque — la
    // vecchia chiave 'state' è morta col polish della lista.
    vcpus: 'vCPU',
    memory: 'Memoria',
    ipAddresses: 'Adresat IP',
    noIp: 'Asnjë IP',
    authorityNode: 'Authority',
    authorityNextStart: 'caktohet në nisjen e ardhshme',
    scope: 'Scope',
    empty: 'Asnjë makinë virtuale',
    loadError: 'Makinat virtuale nuk mund të ngarkoheshin — a është i arritshëm backend-i TVirt?',
    filterOverlay: 'rrjet overlay',
    filterDisk: 'disk',
    filterImage: 'imazh',
    filteredBy: 'Të filtruara sipas {kind}',
    filterPhase: 'Faza',
    filterProtection: 'Mbrojtja',
    filterAll: 'Të gjitha',
    filterScopePlaceholder: 'Filtro sipas scope-it',
    filtersToggle: 'Filtrat',
    scopeTree: {
      title: 'Scope',
      all: 'I gjithë klasteri',
      noChildren: 'Asnjë nën-scope këtu',
      recursive: 'Përfshi pasardhësit',
      collapse: 'Palos panelin e scope-ve',
      up: 'Ngjitu një nivel',
      countTooltip: '{direct} VM në këtë scope · {total} me pasardhësit'
    },

    // Il picker ISO a due passi (#85): prima il catalogo, poi le sue ISO.
    isoPicker: {
      catalog: 'Katalogu',
      unknownCatalog: 'Jashtë katalogëve të dukshëm',
      noIsos: 'Asnjë imazh ISO gati në këtë katalog'
    },
    actionsHeader: 'Veprimet',
    templatesTab: {
      quickDeploy: 'QuickDeploy',
      hardware: 'Hardware',
      tags: 'Tag',
      age: 'Mosha',
      disk: 'disk',
      disks: 'disqe',
      empty: 'Asnjë shabllon — shëno si shabllon një VM të fikur, ose klono një VM si shabllon.',
      clone: 'Klono / deploy',
      editTags: 'Modifiko tag-et',

      // Round K3 (#64): esporta il template come file .tvtpl del catalogo.
      exportAction: 'Eksporto në katalog (.tvtpl)',
      exportTitle: 'Eksporto në katalog',
      exportSubmit: 'Eksporto',
      exportError: 'Eksportimi nuk u krye',
      exportHint: 'Shablloni paketohet në një arkiv .tvtpl (manifest hardware + çdo disk i rrafshuar në qcow2) si skedar i ri Shabllon VM në katalogun e zgjedhur. NIC-et, mediat CD/DVD dhe cloud-init nuk udhëtojnë — spec-i i formatit e liston çdo lëshim të qëllimshëm.',
      exportName: 'Emri i skedarit',
      exportNameHint: 'Bosh = <template>-export-<n>',
      exportStorageDefault: 'Storage-i i metadatave i shabllonit',

      // Importa da catalogo (Luca 2026-08-03): l'ingresso in toolbar del tab
      // Template — il backend K3/K4 copre tutti i formati vm-template, la
      // scelta è il FILE (il formato viaggia in sola lettura).
      importAction: 'Importo nga katalogu',
      importTitle: 'Importo nga katalogu',
      importHint: 'Një skedar Shabllon VM ready i katalogut të zgjedhur bëhet një shabllon i inventarit: formati i skedarit (tvtpl, ova, ovf ose qcow2 i zhveshur) vendos vetë si importohet — ti zgjedh vetëm skedarin.',
      importFile: 'Skedar katalogu',
      importFileHint: 'Importohen vetëm skedarë ready — një në gjysmë upload-i nuk është i importueshëm',
      importNoFiles: 'Asnjë skedar Shabllon VM ready në këtë katalog — më parë ngarko ose eksporto një'
    },
    templateDetail: {
      quickDeploy: 'Përputhshmëria me QuickDeploy',
      quickDeployNone: 'E padeklaruar',
      quickDeployHint: 'Deklarojeni vetëm nëse imazhi golden përmban cloud-init (Linux) ose cloudbase-init pas sysprep /generalize (Windows): platforma i beson deklaratës dhe nuk shikon kurrë brenda mysafirit.',
      notFound: 'Shablloni nuk u gjet',
      frozen: 'Konfigurimi hardware është i ngrirë: rikonvertoje shabllonin në VM për ta modifikuar. Emri, shënimet dhe tag-et mbeten të modifikueshëm.',
      storage: 'Storage',
      size: 'Madhësia',
      configTitle: 'Konfigurimi (i ngrirë)',
      usbClasses: 'Klasa USB të kërkuara',
      gpuClasses: 'Klasa GPU të kërkuara'
    },
    sharedDisksTab: {
      title: 'Disqe të ndara',
      sharing: 'Ndarja',
      sharingNone: 'Një lidhje e vetme',
      sharingMultiwriter: 'Shkrim i ndarë (multiwriter)',
      sharingReadonly: 'Vetëm lexim i ndarë',
      usedBy: 'Në përdorim nga',
      attachedTo: 'Lidhur me',
      notAttached: 'Nuk është lidhur me asnjë VM',
      changeSharing: 'Ndrysho mënyrën e ndarjes',
      changeSharingTitle: 'Mënyra e ndarjes',
      changeSharingLocked: 'Mënyra ndryshohet vetëm kur asnjë VM nuk e përdor diskun',
      sharingChanged: 'Mënyra e ndarjes u përditësua.',
      lun: 'LUN i plotë',
      lunNumber: 'LUN / namespace',
      lunWwn: 'WWN',
      lunSerial: 'Numri serial',
      antiAffinityWarning: 'Dy ose më shumë anëtarë ekzekutohen në të njëjtin nyje pa një rregull anti-afiniteti: dështimi i një nyjeje i rrëzon të gjithë',
      antiAffinityCreate: 'Krijo rregullin',
      createSourceLun: 'Adopto një LUN të plotë të target-it',
      createLunNumber: 'Numri i LUN-it (id e namespace në NVMe)',
      createLunHint: 'Asgjë nuk alokohet: madhësia vërehet nga pajisja në adoptim',
      noPr: 'Në këtë version nuk ka SCSI-3 persistent reservations: një Windows Failover Cluster me disk të ndarë klasik nuk është validuar; grupimet që koordinohen përmes rrjetit (GFS2/OCFS2, RHEL HA, baza të dhënash shared-disk) po'
    },
    unusedDisksTab: {
      title: 'Disqe të papërdorur',
      attach: 'Lidhe me një VM',
      attachTitle: 'Lidhe me një VM',
      vm: 'Makina virtuale',
      noVms: 'Asnjë VM e disponueshme',
      noSlots: 'Asnjë slot i lirë në këtë VM',

      // Crea disco standalone (#87): tornato dall'Inventario pensionato, ora
      // con campo scope ESPLICITO (non c'è una VM da cui ereditare).
      create: 'Krijo disk',
      createTitle: 'Krijo disk',
      createSourceBlank: 'Disk bosh',
      createSourceImage: 'Nga një imazh i katalogut',
      createImage: 'Imazh',
      createImageEmpty: 'Asnjë imazh i gatshëm i shabllonit VM në katalogët e dukshëm',
      createSizeFromImageHint: 'Paraplotësuar me madhësinë virtuale të imazhit — mund vetëm të rritet',

      // #107 (DISTRUTTIVO, ratificato): qcow2 → catalog file vm-template
      // sullo stesso storage, zero byte copiati — il disco cessa di esistere.
      convert: 'Konverto në shabllon VM…',
      convertOnlyQcow2: 'Konvertohen vetëm disqe qcow2 — raw nuk është një format shablloni i regjistrueshëm',
      convertTitle: 'Konverto në shabllon VM',
      convertSubmit: 'Konverto (e shkatërron diskun)',
      convertError: 'Konvertimi nuk mund të nisej',
      convertWarning: 'SHKATËRRUES: disku bëhet një skedar shablloni VM në katalogun e zgjedhur — i njëjti storage, zero byte të kopjuar — dhe PUSHON SË EKZISTUARI si disk. Nuk kthehesh pas veçse duke krijuar një disk të ri nga shablloni.',
      convertNameHint: 'Emri i skedarit të katalogut — i parazgjedhur ai i diskut',
      convertConfirm: 'E kuptova: disku do të shkatërrohet',
      convertStarted: 'Konvertimi u nis — shablloni shfaqet në katalog me përfundimin e task-ut.',
      storageLockHint: 'Storage-i ndryshohet vetëm me veprimin Zhvendos',
      source: 'Prejardhja',
      sourceClone: 'Klon i një disku tjetër',
      sourceCloneLinked: 'Linked clone i një disku tjetër',
      sourceImage: 'Krijuar nga një imazh',
      sourceBlank: 'Krijuar bosh',
      allocated: 'I alokuar / madhësia virtuale',
      observedAt: 'Vëzhguar më',
      snapshots: 'Snapshot',
      snapshotsEmpty: 'Asnjë snapshot'
    },
    phase: {
      defined: 'Asnjëherë e ndezur',
      starting: 'Duke u nisur',
      running: 'Në ekzekutim',
      stopping: 'Duke u ndalur',
      stopped: 'E fikur',
      paused: 'Në pauzë',
      failed: 'Në gabim',
      deleting: 'Duke u fshirë'
    },
    stopCause: {
      'api': 'Ndalur nga TVirt (veprim ose API)',
      'guest-shutdown': 'Shutdown i nisur nga sistemi operativ guest',
      'crash': 'Crash i guest-it',
      'qemu-exit': 'Procesi QEMU përfundoi papritur',
      'host-reboot': 'Nyja u rinis',
      'migrated': 'E migruar në një nyjë tjetër',
      'fenced': 'E asgjësuar nga fencing-u HA (nyja u rikthye)'
    },
    detail: {
      notFound: 'Makina virtuale nuk u gjet',
      details: 'Detajet',
      id: 'ID',
      scope: 'Scope',
      profile: 'Profili hardware',
      firmware: 'Firmware',
      firmwareFile: 'Versioni i firmware-it UEFI',
      firmwareUpdate: 'Përditësim i disponueshëm',
      firmwareUpdateHint: 'Platforma sjell një firmware UEFI më të ri. Përditësimi nuk është kurrë automatik: zbatohet me VM-në të fikur, kur e vendos ti.',
      arch: 'Arkitektura',
      node: 'Nyja',
      bootOrder: 'Radha e boot-it',
      agent: 'Gjendja e agent-it',
      agentConnected: 'I lidhur',
      agentNotConnected: 'I palidhur',
      protected: 'E mbrojtur',
      linkedClones: 'Klone të lidhur',
      restartPolicy: 'Politika e rinisjes',
      preferredNode: 'Nyja e preferuar',
      noPreference: 'Asnjë preferencë (placement automatik)',
      preferNodes: 'Tag-e nyjesh të preferuar',
      requireNodes: 'Tag-e nyjesh të detyrueshëm',
      noPlacementTags: 'Asnjë',
      placementTag: 'Tag',
      placementValue: 'Vlera',
      placementAddTag: 'Shto tag',
      proximityHa: 'HA e TVirt Proximity',
      proximityHaRestarts: 'rinisje HA',
      proximityHaGaveUp: 'crash loop — HA në dorëzim',
      failoverProtection: 'Mbrojtja në degradim',
      protectionProtected: 'E mbrojtur',
      protectionExpendable: 'E sakrifikueshme në degradim',
      protectionInherit: 'Trashëgon',
      lastStop: 'Ndalimi i fundit',
      yes: 'Po',
      no: 'Jo',
      tabOverview: 'Panorama',
      tabSnapshots: 'Snapshot',
      tabBackups: 'Kopjet',
      hardware: 'Hardware',
      name: 'Emri',
      hwSystem: 'Sistemi',
      hwCpu: 'CPU',
      hwMemory: 'Memoria',
      hwBoot: 'Nisja',
      hwIdentity: 'Identiteti',
      hwCluster: 'Klasteri dhe agent-i',
      cpuTopology: 'Topologjia e CPU-së',
      cpuModel: 'Modeli i CPU-së',
      cpuLimit: 'Kufiri i CPU-së',
      cpuWeight: 'Pesha e CPU-së',
      cpuNested: "Virtualizim i ndërfutur",
      cpuNestedHint: "I ekspozon vmx/svm mysafirit (vetëm me modelin e CPU-së host). Në një VM të ndezur ndryshimi hyn në fuqi në power cycle-in e ardhshëm (PendingRestart); vendosja pranon vetëm nyje me nested të aktivizuar.",
      unlimited: 'I pakufizuar',
      memory: 'Memoria',
      balloon: 'Balloon',
      hugePages: 'Faqet e mëdha',
      hugePagesTradeoff: 'Më pak punë përkthimi adresash dhe memorie që s’përfundon kurrë në disk; në këmbim rezerva mbetet e bllokuar në nyjë sa kohë VM-ja është e ndezur, memoria nuk deduplikohet më dhe nisja dështon nëse nyja s’ka mjaftueshëm faqe të lira.',
      disks: 'Disqet',
      cdroms: 'Lexuesit CD/DVD',
      nics: 'Ndërfaqet e rrjetit',
      slot: 'Slot',
      disk: 'Disku',
      encrypted: 'I enkriptuar',
      image: 'Imazhi',
      emptyDrive: 'Lexues bosh',
      emptyOption: '(bosh)',
      network: 'Rrjeti',
      mac: 'MAC',
      connected: 'E lidhur',
      unplugged: 'E shkëputur',
      noDevices: 'Asnjë',
      screenshot: 'Screenshot',
      capturedAt: 'Kapur në',
      noCapture: 'Asnjë kapje',
      snapshotName: 'Emri',
      snapshotCreated: 'Krijuar',
      snapshotMemory: 'Memoria e përfshirë',
      noSnapshots: 'Asnjë snapshot',
      pendingRestart: 'Ndryshime në pritje: do të zbatohen në power cycle-in e ardhshëm.',
      applied: 'i zbatuar',
      appliedHint: 'VM-ja po ekzekutohet me këtë vlerë — ajo e konfiguruara zbatohet në power cycle-in e ardhshëm.',
      actionError: 'Veprimi nuk u krye',
      actionStillRunning: 'Veprimi është ende në proces: përfundimi nuk dihet ende',
      tabConsole: 'Konsola',
      consoleConnect: 'Lidhu',
      consoleDisconnect: 'Shkëputu',
      consoleConnecting: 'Duke u lidhur…',
      consoleReconnecting: 'Duke u lidhur…',
      consoleUnavailable: 'Konsola është e disponueshme me VM-në në ekzekutim ose në pauzë.',
      consoleError: 'Lidhja me konsolën nuk u krye',
      consoleTaken: 'Sesioni i konsolës u mor nga {user}',
      consoleReconnect: 'Rilidhu',
      consoleCtrlAltDel: 'Ctrl+Alt+Del',
      consoleHold: 'Mbaj shtypur {key}',
      consoleFn: 'Fn…',
      consoleFullscreen: 'Hap në ekran të plotë në një tab të ri',
      consoleLoadFailed: 'VM e pagjetur ose leje të pamjaftueshme',
      consoleClose: 'Mbyll',
      tabStats: 'Statistikat',
      tabTasks: 'Task',
      tabLogs: 'Log',
      statsCpu: 'CPU',
      statsMemory: 'Memoria',
      statsDisk: 'I/O disku',
      statsRange: 'Intervali',
      statsNoData: 'Asnjë e dhënë në interval — statistikat kampionohen me VM-në në ekzekutim.',
      statsError: 'Statistikat nuk mund të ngarkoheshin',
      cpuUsage: 'Përdorimi',
      cpuReady: 'Ready (%RDY)',
      memUsed: 'E përdorur',
      memGuestAvailable: 'E disponueshme (guest)',
      schema: 'Skema',
      consoleProtocol: 'Konsola',
      agentEnabled: 'Guest agent',
      metadataStorage: 'Storage i metadatave',
      startupOnBoot: 'Nisje në boot',
      startupOrder: 'Radha e nisjes',
      startupDelay: 'Vonesa e nisjes',
      seconds: 's',
      enabled: 'I aktivizuar',
      disabled: 'I çaktivizuar'
    },
    actionsAvailable: 'Veprime të disponueshme',
    actions: {
      start: 'Nis',
      stop: 'Ndalo',
      pause: 'Pauzë',
      resume: 'Rimerr',
      reset: 'Reset',
      migrate: 'Migro',
      clone: 'Klono',
      moveStorage: 'Zhvendos në storage…',
      moveScope: 'Zhvendos në scope…',
      openConsole: 'Hap konsolën',
      forceStop: 'Detyro fikjen',
      markTemplate: 'Shëno si shabllon',
      unmarkTemplate: 'Rikonverto në VM',
      error: 'Veprimi nuk mund të ekzekutohej'
    },
    cordon: {
      confirmTitle: 'Nyja është në mirëmbajtje',
      confirmHint:
        'Kordoni nuk mund të ulet ndërsa store i grupimit është jashtë funksionit. Duke konfirmuar deklaron se e di: VM-ja ndizet atje gjithsesi, dhe pëlqimi mbetet i regjistruar në task.',
      confirm: 'Ndize gjithsesi'
    },
    markTemplate: {
      confirmTitle: 'Të shënohet {name} si shabllon?',
      confirmBody: 'Konfigurimi ngrin dhe VM-ja nuk do të mund të ndizet më — vetëm të klonohet, ose të rikthehet VM. Emri, shënimet dhe tag-et mbeten të modifikueshëm.',
      confirm: 'Shëno si shabllon',
      moved: '{name} tani është një shabllon — u zhvendos në tab-in Shabllonet.'
    },
    unmarkTemplate: {
      confirmTitle: 'Të rikonvertohet {name} në VM?',
      confirmBody: 'Shablloni rikthehet një VM e zakonshme: e modifikueshme dhe e nisshme (nisja e ardhshme e vendos në një nyjë).',
      confirm: 'Rikonverto në VM',
      moved: '{name} është sërish një makinë virtuale — u zhvendos në tab-in Makinat virtuale.'
    },

    // Round #123: riferimento a nodo per TAG (selettore #106) nei dialog
    // di start e migrazione — anteprima dell'insieme risolto inclusa.
    nodeByTag: {
      label: 'Sipas tag-eve të nyjes',
      hint: 'tag=vlerë, të ndarë me presje (në AND): decider-i zgjedh mes nyjeve përkatëse',
      invalid: 'Format i pavlefshëm — përdor tag=vlerë, të ndarë me presje',
      resolved: 'Anëtarët përkatës: {nodes}'
    },
    migrate: {
      title: 'Live migration',
      submit: 'Migro',
      target: 'Nyja e destinacionit',
      auto: 'Automatike (Proximity)',
      hint: 'VM-ja zhvendoset pa power cycle. Çdo storage që prek duhet të jetë i përbashkët; një VM në pauzë migron në pauzë.',
      error: 'Migrimi u refuzua'
    },
    moveStorage: {
      title: 'Zhvendos në storage',
      submit: 'Zhvendos',
      target: 'Storage-i i destinacionit',
      noTargets: 'Asnjë storage nuk pranon disqe',
      hint: 'Të gjithë disqet e VM-së së fikur udhëtojnë në storage-in e zgjedhur, një nga një, duke ruajtur id-në e tyre — ata tashmë në destinacion kapërcehen. Progresi jeton në faqen e task-eve.',
      error: 'Zhvendosja u refuzua'
    },
    moveScope: {
      title: 'Zhvendos në scope',
      submit: 'Zhvendos',
      target: 'Scope-i i destinacionit',
      hint: 'VM-ja e ndërron scope-in menjëherë — id-ja dhe disqet mbeten, disqet owned e ndjekin, dhe mund të mbetet e ndezur. Sot jeton në {scope}. Kush e sheh ndryshon me scope-in.',
      error: 'Zhvendosja e scope-it u refuzua'
    },
    start: {
      title: 'Nis VM-në',
      submit: 'Nis',
      target: 'Nyja e destinacionit',
      auto: 'Automatike (e këshilluar)',
      recommended: 'e këshilluar',
      hint: 'Zgjidh një nyjë destinacioni ose lëre Proximity të vendosë mes kandidatëve të vlefshëm. Nyjet që s’mund ta strehojnë janë të çaktivizuara me arsyen.',
      error: 'VM-ja nuk mund të nisej'
    },
    console: {
      media: 'Lexuesit CD/DVD',
      mediaGuestToolsHint: 'Përmban TVirt Guest Tools — prej këtu mund t’i nxjerrësh ose të heqësh lexuesin',
      slotOpsDeferred: 'Në këtë profil shtimi dhe heqja e lexuesve zbatohen në power cycle-in e ardhshëm (ndërrimet e mediave janë të menjëhershme).',
      mountGuestTools: 'Monto TVirt Guest Tools',
      ejectGuestTools: 'Nxirr TVirt Guest Tools',
      bootOrder: 'Radha e boot-it',
      bootOrderHint: 'Radha e re ruhet menjëherë dhe zbatohet në power cycle-in e ardhshëm — sesioni i konsolës mbetet i lidhur.'
    },
    snapshots: {
      create: 'Krijo snapshot',
      createTitle: 'Krijo një snapshot',
      createSubmit: 'Krijo',
      name: 'Emri',
      nameHint: 'Shkronja, shifra, pikë, vijë ndarëse, underscore.',
      consistencyHint: 'Konsistenca është automatike: guest agent-i i ngrin filesystem-et kur përgjigjet; përndryshe VM-ja shkon në pauzë për një çast rreth snapshot-it.',
      memory: 'Përfshi memorien',
      memoryHint: 'Kap RAM-in e gjallë: rikthimi e rimerr VM-në në ekzekutim. Kërkon të gjithë disqet qcow2.',
      currentChip: 'Je këtu',
      revert: 'Rikthe',
      revertTitle: 'Të rikthehet {name}?',
      revertBody: 'Disqet kthehen në gjendjen e snapshot-it; gjithçka që ka ndodhur më pas humbet. Një snapshot vetëm-disqe kërkon VM-në të ndalur.',
      delete: 'Fshi',
      deleteTitle: 'Të fshihet snapshot-i {name}?',
      deleteBody: 'Pika e rikthimit zhduket; përmbajtja e disqeve mbetet e paprekur.',
      deleteMergeHint: 'Delta e tij shkrihet në {children}: çdo pikë rikthimi e mëvonshme mbetet e vlefshme.',
      deleteDuplication: 'E pranoj dyfishimin',
      deleteDuplicationHint: 'Delta kopjohet në secilin nga {count} lexuesit (snapshot-et fëmijë dhe, nëse ky është ai aktual, koka aktive): hapësira e zënë mund të rritet në vend që të ulet.',
      error: 'Operacioni mbi snapshot-in u refuzua'
    },
    clone: {
      title: 'Klono VM-në',
      submit: 'Klono',
      name: 'Emri i kopjes',
      storage: 'Storage-i i destinacionit i disqeve',
      sameStorage: 'I njëjti me burimin',
      full: 'Kopje e plotë',
      fullHint: 'Kopjon çdo byte dhe e pret lidhjen me disqet burim. Default-i është një linked clone: i menjëhershëm, por i vargëzuar me burimin (vetëm qcow2).',
      hint: 'Kloni mban konfigurimin dhe firmware-in e burimit; adresat MAC dhe identiteti TPM janë të rinj.',
      markAs: 'Tipi i klonit',
      markAsInheritVm: 'Si burimi (VM)',
      markAsInheritTemplate: 'Si burimi (shabllon)',
      markAsVm: 'Makinë virtuale',
      markAsTemplate: 'Shabllon',
      markAsHintVm: 'Zgjidh Shabllon për ta promovuar kopjen me një hap të vetëm.',
      markAsHintTemplate: 'Zgjidh Makinë virtuale për të bërë deploy nga ky shabllon me një hap të vetëm.',
      error: 'Klonimi u refuzua'
    },
    bulk: {
      selected: 'të zgjedhura',
      deleteTitle: {
        one: 'Të fshihet {count} VM-ja e zgjedhur?',
        other: 'Të fshihen {count} VM-të e zgjedhura?'
      },
      deleteBody: 'Secila VM kalon të njëjtat roje si delete-i i vetëm; refuzimet raportohen për element.',
      done: 'të pranuara',
      refused: 'të refuzuara'
    },
    delete: {
      button: 'Fshi',
      confirmTitle: 'Të fshihet {name}?',
      confirmBody: 'Makina virtuale dhe disqet në pronësinë e saj do të fshihen. Operacioni nuk është i kthyeshëm.',
      keepDisks: 'Mbaji disqet',
      keepDisksHint: 'Disqet e krijuar me VM-në mbeten në storage-in e tyre si disqe autonomë.',
      confirm: 'Fshi',
      cancel: 'Anulo',
      error: 'Fshirja nuk u krye',
      blockedPhase: 'Ndalo më parë VM-në',
      blockedProtected: 'VM-ja është e mbrojtur — hiq më parë mbrojtjen',
      blockedDeleting: 'Fshirja tashmë në proces'
    },
    logs: {
      title: 'Log',
      subtitle: 'Frame log-u të strukturuar të task-eve që e prekin këtë VM',
      when: 'Kur',
      task: 'Task',
      level: 'Niveli',
      message: 'Mesazhi',
      empty: 'Ende asnjë log',
      loadError: 'Log-et nuk mund të ngarkoheshin — a është i arritshëm backend-i TVirt?'
    },
    stop: {
      title: 'Ndalo makinën virtuale',
      modeGraceful: 'Fikje graceful',
      modeGracefulHint: 'Sistemit operativ guest i kërkohet të fiket në mënyrë natyrale (ACPI); nëse e injoron kërkesën, pas timeout-it hyn në veprim fikja e detyruar.',
      modeForced: 'Fikje e detyruar',
      modeForcedHint: 'E ndërpret rrymën menjëherë, si të hiqje spinën.',
      timeout: 'Timeout-i i fallback-ut (sekonda)',
      timeoutHint: 'Pritja që i jepet guest-it para se të detyrohet fikja'
    },

    // Il menu del bottone split di creazione (Luca 2026-07-23): "Da zero" apre
    // il wizard, le altre due voci sono stub di roadmap.
    createFromScratch: 'Nga zero',
    createFromTemplate: 'Nga shablloni',
    createQuickDeploy: 'TVirt QuickDeploy',

    quickDeploy: {
      title: 'TVirt QuickDeploy',
      submit: 'Ekzekuto deploy',
      error: 'Deploy dështoi',
      compatNote: 'QuickDeploy kërkon një shabllon të përputhshëm me QuickDeploy: platforma personalizon mysafirin (rrjet, domen, aktivizim) në nisjen e parë.',
      template: 'Shabllon',
      noTemplates: 'Asnjë shabllon nuk deklaron ende përputhshmëri me QuickDeploy — deklarojeni nga skeda Shabllonet (Linux me cloud-init, Windows me cloudbase-init pas sysprep)',
      osLinux: 'Linux (cloud-init)',
      osWindows: 'Windows (cloudbase-init)',
      hostname: 'Emri i hostit',
      hostnameHint: 'Emri i hostit ose FQDN; bosh = emri i VM-së (Windows: më së shumti 15 karaktere)',
      ip: 'Adresa IP',
      ipHint: 'Host dhe prefiks, p.sh. 192.168.122.101/24; bosh = DHCP',
      gateway: 'Gateway',
      dns: 'Serverët DNS',
      dnsHint: 'Deri në tre, të ndarë me presje',
      count: 'Instanca',
      countHint: 'Më shumë se një: të emërtuara <emri>-1…-N, vetëm DHCP',
      user: 'Përdorues',
      userHint: 'Bosh = përdoruesi i parazgjedhur i imazhit (Linux) ose Administrator (Windows)',
      password: 'Fjalëkalim',
      passwordHint: 'Shkruhet në user-data të gjeneruar, të cilën platforma e deklaron më pas sekrete: askush nuk e lexon më',
      sshKeys: 'Çelësa publikë SSH',
      sshKeysHint: 'Një për rresht (ssh-ed25519 AAAA… koment)',
      productKey: 'Product key i Windows',
      kmsServer: 'Serveri KMS',
      kmsHint: 'Host ose host:portë — kërkon një product key (një çelës klienti KMS)',
      adDomain: 'Bashkohu me domenin Active Directory',
      adDomainHint: 'Bosh = pa bashkim me domenin',
      adUser: 'Llogaria e bashkimit',
      adPassword: 'Fjalëkalimi i llogarisë së bashkimit',
      adOu: 'OU e destinacionit (opsionale)',
      advanced: 'Të avancuara: dokumente të papërpunuara',
      userData: 'user-data (e papërpunuar)',
      userDataHint: 'Zëvendëson user-data të gjeneruar: përdoruesi, fjalëkalimi, çelësat dhe fushat Windows më sipër duhet të mbeten bosh',
      networkConfig: 'network-config (e papërpunuar)',
      networkConfigHint: 'Zëvendëson rrjetin e gjeneruar: IP, gateway dhe DNS më sipër duhet të mbeten bosh',
      secret: 'Trajtoje user-data të papërpunuar si sekrete',
      secretHint: 'E shënuar si sekrete, API nuk ia kthen më askujt dhe udhëton në Checkpoint e vulosur me masterpass',
      startNow: 'Nis menjëherë',
      startNowHint: 'Çdo instancë niset sapo përcaktohet; seed-i krijohet në atë nisje'
    },

    create: {
      nicAttachmentNetwork: 'Rrjet logjik (fabric)',
      nicNetwork: 'Rrjet logjik',
      nicNetworkHint: 'Rruga e REKOMANDUAR (F3): vNIC realizohet mbi bridge-in e DERIVUAR të nyjes shërbyese — bridge-i lind në apply-in eksplicit të fabric-ut, dhe një nisje në një nyje që ende s\'e mban refuzon duke folur. Kur ikën referenca e fundit e flotës, bridge-i bie në apply-in e ardhshëm.',
      button: 'Krijo VM',
      title: 'Krijo makinë virtuale',
      dialogTitle: 'Krijo makinë virtuale',
      stepGeneral: 'Të përgjithshme',
      stepGeneralHint: 'Emri dhe profili',
      stepCompute: 'CPU dhe RAM',
      stepComputeHint: 'Topologjia dhe përmasat',
      stepDisks: 'Disqet',
      stepDisksHint: 'Krijo ose lidh',
      stepCdroms: 'CD/DVD',
      stepCdromsHint: 'Lexues dhe media',
      stepNetwork: 'Rrjeti',
      stepNetworkHint: 'NIC: trunk ose bridge',
      stepSummary: 'Përmbledhja',
      stepSummaryHint: 'Verifiko dhe krijo',
      name: 'Emri',
      nameHint: 'Shkronja të vogla, shifra dhe vija ndarëse (DNS-1123)',
      nextButton: 'Përpara',
      prevButton: 'Prapa',
      submitButton: 'Krijo',
      creating: 'Duke krijuar…',
      sockets: 'Socket',
      cores: 'Core për socket',
      threads: 'Thread për core',
      totalVcpus: 'vCPU gjithsej',
      memoryGib: 'Memoria (GiB)',
      cpuModelHint: "'host' ekspozon CPU-në e host-it",
      cpuLimitHint: 'Tavan në core host — bosh = i pakufizuar',
      cpuNestedHint: "I ekspozon vmx/svm mysafirit që të ekzekutojë hipervizorin e vet — kërkon modelin e CPU-së host dhe një nyje me nested të aktivizuar",
      newDisk: 'Disk i ri',
      attachDisk: 'Lidh disk ekzistues',
      diskStorage: 'Storage',
      diskSize: 'Madhësia (GiB)',
      diskSelect: 'Disku',
      addDisk: 'Shto disk',
      addCdrom: 'Shto lexues CD/DVD',
      addNic: 'Shto ndërfaqe rrjeti',
      remove: 'Hiq',
      slotLimit: 'Kufiri i sloteve u arrit',
      cdromImage: 'Imazhi (lexues bosh nëse mungon)',
      nicAttachment: 'Lidhja',
      nicAttachmentTrunk: 'Trunk overlay',
      nicAttachmentBridge: 'Bridge host',
      nicUntagged: 'Overlay untagged',
      nicUntaggedNone: 'Asnjë (vetëm tagged)',
      nicTrunkHint: 'Të paktën një anë: një overlay untagged dhe/ose përkthime VLAN tagged — VM-ja mund të ekzekutohet vetëm në host-et e deklaruar nga secili overlay i referuar',
      nicTaggedVlan: 'ID e VLAN-it',
      nicTaggedOverlay: 'Rrjeti overlay',
      addTagged: 'Shto VLAN tagged',
      nicBridge: 'Emri i bridge-it host',
      nicBridgeHint: 'Bridge NM sipas emrit — VM-ja mund të ekzekutohet vetëm në serverët host network-u i të cilëve e deklaron këtë bridge',
      nicMac: 'MAC (auto nëse bosh)',
      noDisksHint: 'Asnjë disk: VM-ja do të ketë vetëm lexuesit CD/DVD që shton.',
      noCdromsHint: 'Asnjë lexues CD/DVD: shto një për të nisur nga imazh ISO.',
      mountGuestTools: 'Monto TVirt Guest Tools në nisjen e parë',
      mountGuestToolsHint: 'E vendos ISO-n me driver-ët virtio dhe guest agent-in në një lexues CD bosh (i shtuar po të duhet) — installer-i i Windows ka nevojë për të që të shohë disqet.',
      noNicsHint: 'Asnjë ndërfaqe rrjeti: VM-ja do të niset pa lidhshmëri.',
      taggedMappings: 'Mapping VLAN tagged',
      summaryDevices: 'Pajisjet',
      bootOrderTitle: 'Radha e boot-it',
      bootOrderHint: 'Tërhiq për të rirenditur — fiton pajisja e parë e nisshme; NIC-et nisin PXE',
      bootOrderUp: 'Ngjite lart',
      bootOrderDown: 'Zbrite poshtë',
      createError: 'Krijimi nuk u krye'
    },
    edit: {
      button: 'Modifiko',
      title: 'Modifiko makinën virtuale',
      cancel: 'Anulo',
      save: 'Ruaj',
      error: 'Modifikimi nuk u krye',
      modelStoppedOnly: 'I modifikueshëm vetëm me VM-në të fikur',
      firmwareStoppedOnly: 'Firmware i modifikueshëm vetëm me VM-në të fikur — në nisjen e ardhshme makina niset me firmware-in e ri dhe variablat UEFI mbeten',
      hugePagesStoppedOnly: 'I modifikueshëm vetëm me VM-në të fikur — në nisjen e ardhshme memoria lind me backing-un e ri',
      runningHint: 'Ndryshimet zbatohen në power cycle-in e ardhshëm',
      sectionCpu: 'CPU',
      sectionMemory: 'Memoria',
      sectionPolicy: 'Kriteret'
    },
    devices: {
      networkChip: 'rrjet fabric',
      title: 'Pajisjet',
      usb: 'USB',
      gpu: 'GPU',
      addUsb: 'Shto pajisje USB',
      addUsbTitle: 'Kërko një klasë pajisjesh USB',
      usbClassHint:
        'VM-ja kërkon një KLASË pajisjesh USB (një vlerë e një tag-u usb-device), kurrë një pajisje të caktuar: në nisje zgjidhet dhe rezervohet pajisja e lirë konkrete në nyjë. Tag-o pajisjet e regjistruara te Klasteri › Burimet USB dhe PCIe.',
      usbTag: 'Tag (usb-device)',
      usbValue: 'Vlera e klasës',
      noUsbTags: 'Asnjë tag usb-device — krijo një dhe tag-o pajisjet e regjistruara te Klasteri › Burimet USB dhe PCIe.',
      noUsbValues: 'Ky tag nuk ka ende vlera të deklaruara.',
      usbEmpty: 'Asnjë kërkesë USB — shto një klasë për të kaluar një pajisje në nisje.',
      usbClassChip: 'klasë',
      usbPortChip: 'portë',
      usbUnclaimed: 'Asnjë pajisje e rezervuar — zgjidhet në nisjen e VM-së.',
      addGpu: 'Shto GPU',
      addGpuTitle: 'Kërko një klasë GPU-sh',
      gpuClassHint:
        'VM-ja kërkon një KLASË GPU-sh (një vlerë e një tag-u gpu-device), kurrë një kartë të caktuar: në nisje karta e lirë konkrete zgjidhet dhe rezervohet në nyjë, dhe kalon BASHKË gjithë grupi i saj IOMMU. Tag-o GPU-të e regjistruara te Klasteri › Burimet USB dhe PCIe.',
      gpuTag: 'Tag (gpu-device)',
      gpuValue: 'Vlera e klasës',
      noGpuTags: 'Asnjë tag gpu-device — krijo një dhe tag-o GPU-të e regjistruara te Klasteri › Burimet USB dhe PCIe.',
      noGpuValues: 'Ky tag nuk ka ende vlera të deklaruara.',
      gpuEmpty: 'Asnjë kërkesë GPU — shto një klasë për të kaluar një kartë në nisje.',
      gpuClassChip: 'klasë',
      gpuGroupChip: 'grup IOMMU ×',
      gpuUnclaimed: 'Asnjë kartë e rezervuar — zgjidhet në nisjen e VM-së.',
      gpuPowerCycle: 'Asnjë hotplug GPU — ndryshimet vlejnë nga power cycle-i i ardhshëm (PendingRestart)',
      actions: 'Veprimet',
      attachDisk: 'Shto disk',
      attachDiskTitle: 'Shto një disk',
      attach: 'Lidh',
      noFreeDisks: 'Asnjë disk i papërdorur — krijo një te Makinat virtuale › Disqe të papërdorur.',
      addCdrom: 'Shto lexues',
      addCdromTitle: 'Shto një lexues CD/DVD',
      editCdromTitle: 'Ndërro imazhin CD/DVD',
      changeMedia: 'Ndërro imazhin CD/DVD',
      ejectMedium: 'Nxirr',
      mountGuestTools: 'Monto TVirt Guest Tools',
      guestToolsMounted: 'TVirt Guest Tools të montuara',
      guestToolsClickMount: 'E vendos ISO-n TVirt Guest Tools në lexuesin e parë CD/DVD bosh',
      guestToolsClickUnmount: 'Kliko për ta nxjerrë — lexuesi mbetet, bosh',
      guestToolsNoSlot: 'Asnjë lexues CD/DVD bosh — shto një lexues (ose nxirr një media) për të montuar TVirt Guest Tools',
      guestToolsSkew: 'Montuar v{pinned}; nyja {node} tani shërben v{current}: nxirre dhe montoje sërish për ta përditësuar',
      ejectGuestTools: 'Nxirr TVirt Guest Tools (lexuesi mbetet, bosh)',
      guestToolsEjectConfirmTitle: 'Të nxirren TVirt Guest Tools?',
      guestToolsEjectConfirmBody: 'Media nxirret nga VM-ja e ndezur — lexuesi CD/DVD mbetet, bosh.',
      applyLive: 'Zbatoje menjëherë (VM-ja është e ndezur)',
      addNic: 'Shto ndërfaqe',
      addNicTitle: 'Shto një ndërfaqe rrjeti',
      editNicTitle: 'Modifiko ndërfaqen e rrjetit',
      bridgeChip: 'bridge',
      cable: 'Kablloja virtuale',
      plug: 'Lidhe kabllon virtuale',
      unplug: 'Shkëpute kabllon virtuale',
      remove: 'Hiq',
      removeTitle: 'Të hiqet {device}?',
      removeBody: 'Me VM-në të ndezur ndryshimi zbatohet në power cycle-in e ardhshëm. Disqet dhe imazhet shkëputen, kurrë nuk fshihen.'
    }
  }
}
